import React, { useEffect } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import './App.css';
import Popup from './features/_shared/components/Popup/popup.container';
import { useStoreSelector } from './_shared/store/hook';
import { PRIVATE_ROUTES, PrivateRoutes } from './_shared/routes';
import { NavigationManager } from './_shared/managers/navigation.manager';
import SideBar from './features/_shared/components/Navbar/sidebar.component';
import LoginHeader from './features/_shared/components/Header/login.header.component';
import Loader from './features/_shared/components/Loader/loader.component';
import { LoginView } from './features/access/views/login.view';
import 'bootstrap-icons/font/bootstrap-icons.css';

export const App: React.FC = () => {
    const history = NavigationManager.getInstance().getHistory();
    const isLoading = useStoreSelector(state => state.reducer.shared.loading.global);
    const isVisible = useStoreSelector(state => state.reducer.shared.popup.isVisible);
    const isLogged = useStoreSelector(state => state.reducer.accessSlice.loggedUser.email);

    return (
        <>
            <Loader isLoading={!!isLoading} />
            <Popup isVisible={isVisible} />
            <div className='app-container d-flex flex-column justify-content-between'>
                {isLogged == '' && <LoginView />}

                {isLogged != '' && (
                    <div className='d-flex'>
                        {isLogged != '' && (
                            <div>
                                <SideBar isLogged={isLogged == '' ? false : true} />
                            </div>
                        )}

                        {isLogged != '' && (
                            <div className={`app-view-container sidepanel-space`}>
                                <div>
                                    <LoginHeader />

                                    <Router history={history}>
                                        <Switch>
                                            <Route exact path='/' component={() => <Redirect to='/home' />} />
                                            {/* <Route path={PUBLIC_ROUTES.map(({ path }) => path)} component={PublicRoutes} /> */}
                                            <Route path={PRIVATE_ROUTES.map(({ path }) => path)} component={PrivateRoutes} />
                                        </Switch>
                                    </Router>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* <Footer /> */}
            </div>
        </>
    );
};

export default App;
